import { render } from "./DirPickMpio.vue?vue&type=template&id=333f881b"
import script from "./DirPickMpio.vue?vue&type=script&lang=ts"
export * from "./DirPickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script